import React from 'react';
import { Form, Button, Modal, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus, faFile } from '@fortawesome/free-solid-svg-icons'; // icons for expand/collapse, and leaf

import {
		textFieldIconData, integerFieldIconData, dropdownFieldIconData, 
		decimalFieldIconData, dateFieldIconData, dateTimeFieldIconData, doubleFieldIconData, booleanFieldIconData
} from './constants';



interface DataModelTreeNodeProps {
  dataModelData: any;
}

interface DataModelTreeNodeState {
  expandedNodes: Set<string>;
}

class DataModelTreeNode extends React.Component<DataModelTreeNodeProps, DataModelTreeNodeState> {
  constructor(props: DataModelTreeNodeProps) {
    super(props);
      
    
    this.state = {
      expandedNodes: props.dataModelData?new Set<string>([props.dataModelData.id]):new Set<string>(),
    };
  }
  
  textFieldIcon: JSX.Element = ( <a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={textFieldIconData} alt="" style={{height: '11px'}}></img>
  </a>);
  integerFieldIcon: JSX.Element = (<a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={integerFieldIconData} alt="" style={{height: '8px'}}></img>
  </a>);
  dropdownFieldIcon: JSX.Element = (<a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={dropdownFieldIconData} alt="" style={{height: '13px'}}></img>
  </a>);
  decimalFieldIcon: JSX.Element = (<a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={decimalFieldIconData} alt="" style={{height: '13px'}}></img>
  </a>);
  dateFieldIcon: JSX.Element = (<a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={dateFieldIconData} alt="" style={{height: '13px'}}></img>
  </a>);
  dateTimeFieldIcon: JSX.Element = (<a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={dateTimeFieldIconData} alt="" style={{height: '13px'}}></img>
  </a>);
  doubleFieldIcon: JSX.Element = (<a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={doubleFieldIconData} alt="" style={{height: '13px'}}></img>
  </a>);
  booleanFieldIcon: JSX.Element = (<a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={booleanFieldIconData} alt="" style={{height: '13px'}}></img>
  </a>);

  componentDidUpdate(prevProps: DataModelTreeNodeProps) {
    if (prevProps.dataModelData !== this.props.dataModelData) {
      console.log('dataModelData prop has changed!');
      this.setState({expandedNodes: this.props.dataModelData?new Set<string>([this.props.dataModelData.id]):new Set<string>()})
    }
  }

  toggleExpand = (id: string) => {
    this.setState((prevState) => {
      const newExpandedNodes = new Set(prevState.expandedNodes);
      if (newExpandedNodes.has(id)) {
        newExpandedNodes.delete(id);
      } else {
        newExpandedNodes.add(id);
      }
      return { expandedNodes: newExpandedNodes };
    });
  };
  

  renderNode = (node: any) => {
    const id = node.id||node.FLD_ID;
    const label = node.label||node.COLUMN_DISPLAY_NAME;
    const isExpanded = this.state.expandedNodes.has(id);
    const hasfield = node.field && node.field.length > 0;
    const lblCss = {paddingLeft:'6px', width:'100%', paddingTop:'3px', paddingBottom: '3px'};
    const labelChk =  <div style={{ display: 'flex'}}>
        <div style={{width:'30px'}} className="d-flex justify-content-center align-items-center">   
            {(node && !node.DATA_TYP) && <FontAwesomeIcon icon={faFile} style={{ marginRight: '15px' }} />}
            {(node && node.DATA_TYP === "TextField") && this.textFieldIcon }
            {(node && node.DATA_TYP === "IntegerField") && this.integerFieldIcon }
            {(node && node.DATA_TYP === "LookupField") && this.dropdownFieldIcon }
            {(node && node.DATA_TYP === "DateField") && this.dateFieldIcon }
            {(node && node.DATA_TYP === "DateTimeField") && this.dateTimeFieldIcon }
            {(node && node.DATA_TYP === "DecimalField") && this.decimalFieldIcon }
        </div>
        <div style={lblCss}>{label}</div>
    </div>

    return (
      <div key={id} style={{ paddingLeft: '20px', marginBottom: '5px' }}>
        <div style={{ display: 'flex',  }}>
          <div style={{}} className="d-flex justify-content-center">
          {hasfield ? (
            <Button
              variant="link"
              size="sm"
              onClick={() => this.toggleExpand(node.id)}
              style={{ marginRight: '5px', marginLeft:'-8px', marginTop: '-4px' }}
            >
              <FontAwesomeIcon icon={isExpanded ? faMinus : faPlus} />
            </Button>
          ) : (
            <>
              
            </>
          )}
          </div>
          <div style={{width:'100%'}}>
            {labelChk}
          </div>
        </div>
        {isExpanded && node.field && (
          <div style={{ paddingLeft: '15px' }}>
            {node.field.map(this.renderNode)}
          </div>
        )}
      </div>
    )
  }

  render() {
    
    const dataModelData = [this.props.dataModelData];
    return(
      
        <Row className="mt-3">
            <Col>
                 <div>{this.props.dataModelData && dataModelData.map(this.renderNode)}</div>
            </Col>
        </Row>
        
          
    )
  }
}

export default DataModelTreeNode;
